const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getInitialCleaning = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_INITIAL_CLEANING_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_INITIAL_CLEANING_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getInitialCleaning;